// Check if a message has been stored in localStorage
// and if so, display to user and remove

import debounce from 'lodash.debounce';

export default {
  async mounted() {
    this.getMessage();
  },
  methods: {
    getMessage: debounce(function () {
      const message = localStorage.getItem('serverToastMessage');

      if (message) {
        this.$toast.open({
          message: `${this.formatMessage(message)}`,
          position: 'top-right',
          duration: '5000',
        });
        localStorage.removeItem('serverToastMessage');
      }
    }, 500),

    formatMessage(message = '') {
      // A quote is represented as %22 and a underscore as %20
      let formatUrl = message
        ?.replaceAll('_', ' ')
        ?.replaceAll('%22', '')
        ?.replaceAll('%20', ' ');
      return this.capitalizeFirstLetter(formatUrl);
    },

    capitalizeFirstLetter(sentence) {
      return sentence?.charAt(0)?.toUpperCase() + sentence?.slice(1);
    },
  },
};
